import { forwardRef } from "react";
import { ValidatedTextInput } from "../inputs";
import { jsx } from "react/jsx-runtime";
const PhoneInput = forwardRef(
  ({
    analyticsName,
    invalidPhoneError = "Please enter a valid phone number.",
    fieldRequiredError = "This field is required.",
    title = "Phone number",
    size = "medium",
    placeholder = "000-000-0000",
    ariaLabelledBy,
    ...props
  }, ref) => /* @__PURE__ */ jsx(
    ValidatedTextInput,
    {
      ref,
      id: "phone",
      analyticsName: `${analyticsName}-phone`,
      format: "telephoneNumber",
      size,
      placeholder,
      customErrorMessages: {
        fieldRequired: fieldRequiredError,
        invalidPhoneNumber: invalidPhoneError
      },
      ...ariaLabelledBy ? { ariaLabelledBy } : { title },
      ...props
    }
  )
);
PhoneInput.displayName = "PhoneInput";
export {
  PhoneInput
};
